import planfree from './free.svg';
import plan10 from './10dc.svg';
import plan30 from './30dc.svg';
import plan100 from './100dc.svg';
import plan250 from './250dc.svg';

export default { planfree, plan10, plan30, plan100, plan250 };
